import React from 'react';
import { Button, Space, Typography, Dropdown, Menu } from 'antd';
import { UserOutlined, LogoutOutlined, ProfileOutlined, DashboardOutlined, MailOutlined } from '@ant-design/icons';
import useAuthStore from '../../stores/authStore';
import { useNavigate } from 'react-router-dom';
import logo from '../img/logo192.png';

const { Text } = Typography;

const UserMenu = ({ isCompact }) => {
  const { isLoggedIn, logout, showLoginModal } = useAuthStore();
  const navigate = useNavigate();

  const getUserData = () => {
    const token = localStorage.getItem('token')?.replace('Bearer ', '');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return {
          email: payload.name || payload.email,
          is_staff: payload.is_staff,
          first_name: payload.first_name || ''
        };
      } catch (error) {
        console.error('Error decoding token:', error);
        return { email: '', is_staff: false, first_name: '' };
      }
    }
    return { email: '', is_staff: false, first_name: '' };
  };

  const getInitials = (name) => {
    return name
      .split(/[ @]/)
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const userData = getUserData();

  // Create a custom dropdown with email header
  const userMenu = (
    <Menu
      style={{
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      }}
    >
      {/* Email display at the top of dropdown */}
      <Menu.Item disabled style={{
        cursor: 'default',
        padding: '12px 16px',
        borderBottom: '1px solid #f0f0f0',
        marginTop: '-4px',
        opacity: 1,
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <Text style={{ fontWeight: 600, fontSize: '14px' }}>
            {userData.first_name ? `Welcome, ${userData.first_name}!` : 'Welcome!'}
          </Text>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <MailOutlined style={{ color: '#1890ff' }} />
            <Text ellipsis style={{ maxWidth: '200px', fontWeight: 500 }}>
              {userData.email}
            </Text>
          </div>
        </div>
      </Menu.Item>
      
      {/* Admin dashboard option */}
      {userData.is_staff && (
        <Menu.Item 
          key="admin" 
          icon={<DashboardOutlined />}
          onClick={() => navigate("/AdminDashboard")}
        >
          Admin Dashboard
        </Menu.Item>
      )}
      
      {/* Profile option */}
      <Menu.Item 
        key="profile" 
        icon={<ProfileOutlined />}
        onClick={() => navigate("/profile")}
      >
        Profile
      </Menu.Item>
      
      {/* Logout option */}
      <Menu.Item 
        key="logout" 
        icon={<LogoutOutlined />}
        onClick={() => {
          logout();
          // Force navigation after state update
          setTimeout(() => {
            navigate('/', { replace: true });
          }, 0);
        }}
      >
        Logout
      </Menu.Item>
    </Menu>
  );

  const avatarStyle = {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    color: 'white',
    textTransform: 'uppercase',
    cursor: 'pointer',
    boxShadow: '0 0px 5px rgba(0,0,0,0.5)',
    backgroundImage: `url(${logo})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    textShadow: '0px 0px 10px rgba(0,0,0,0.9)', // Add text shadow for better visibility
    fontWeight: 'bold',
  };

  return (
    <Space>
      {isLoggedIn ? (
        <Dropdown 
          overlay={userMenu} 
          trigger={["click"]} 
          placement="bottomRight"
          getPopupContainer={triggerNode => triggerNode.parentNode}
          //overlayStyle={{ marginTop: '20px' }}
        >
          <div style={avatarStyle}>
            {getInitials(userData.email)}
          </div>
        </Dropdown>
      ) : (
        <Text 
          onClick={showLoginModal}
          style={{
            cursor: 'pointer',
            //color: '#1890ff',
            fontSize: '14px',
            fontWeight: 500,
          }}
        >
          Log In
        </Text>
      )}
    </Space>
  );
};

export default UserMenu;
